import { ENTITY_TYPES } from '../constants/knowledge.constants';

/**
 * Check if the data has results
 * @param {*} data
 * @returns
 */
export const hasResults = data =>
  data
    ? Object.values(data).some(category => Object.values(category).some(value => value > 0))
    : false;

/**
 * Filter by tags
 * True - show files
 * False - hide files
 *
 * @param {Boolean} { filters }
 */
export const filterByTags =
  ({ filters }) =>
  ({ tags, labels = [], professional, type }) => {
    try {
      if (filters.SPECIALTY.size > 0 && !filters.SPECIALTY.has(tags.specialty)) {
        return false;
      }

      if (filters.SUBSPECIALTY.size > 0 && !filters.SUBSPECIALTY.has(tags.subspecialty)) {
        return false;
      }

      if (filters.CONTENT_TYPE.size > 0 && !filters.CONTENT_TYPE.has(tags.contentType)) {
        return false;
      }

      if (filters.TARGET_AUDIENCE.size > 0) {
        const targetAudience = tags.targetAudience.some(key => filters.TARGET_AUDIENCE.has(key));

        if (!targetAudience) {
          return false;
        }
      }

      if (filters.LABELS.size > 0) {
        // For contacts, check location in professional.location
        if (type === ENTITY_TYPES.contacts && professional?.location) {
          const locationMatch = professional.location.some(key => filters.LABELS.has(key));
          if (!locationMatch) {
            return false;
          }
        } else {
          // For other content types, check labels
          const label = labels.some(key => filters.LABELS.has(key));
          if (!label) {
            return false;
          }
        }
      }

      return true;
    } catch (e) {
      return false;
    }
  };

/**
 * Identity of a search query (term + active tag filters + tab). Used to dedupe
 * the duplicate request a term change would otherwise cause: changing the term
 * resets the tag filters, which re-enters the filter effect with the same query
 * the term-sync effect already fired. Empty filter sets are ignored, so an
 * explicit empty object and the reset's empty-Set shape compare equal.
 *
 * @param {string} term
 * @param {{ searchType?: string|null } & Record<string, Set|Array>} filtersObj
 * @returns {string}
 */
export const buildSearchSig = (term, filtersObj = {}) => {
  const { searchType = null, ...filters } = filtersObj;
  const filterPart = Object.keys(filters)
    .sort()
    .map(key => {
      const values = [...(filters[key] || [])].sort();
      return values.length ? `${key}:${values.join(',')}` : null;
    })
    .filter(Boolean)
    .join('|');
  return `${term}|${searchType || ''}|${filterPart}`;
};
